/* Raghu  27/10/2022 3075154998 Table Alignments and Enhancements
akhila    10/28/2022 3075154998 enable framework UX changes
akhila 11/01/2022 3075154998 TablePagination bugFix
saikrishna 11/03/2022 3075154998 changed the paginationOptions

*/
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination, Button} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost, httpPaginationDelete} from '../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {fetchEnableFileFormatData} from '../../../../../redux/reducers/EnableFramework/AddEnableFileFormat';
import {SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import PlayCircleFilledWhiteOutlinedIcon from '@material-ui/icons/PlayCircleFilledWhiteOutlined';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import reusableInputStyles from '../../../../../components/InputStyles';

export default function EnableFileFormatSearchTable({
  setTabValue,
  setEnableCode,
  searchData,
  setSearchData,
  submit,
  setSubmit,
  setResetData,
  setOpen,
  setJobCode,
}) {
  const [message, setMessage] = useState('');
  const columns = [
    {
      title: 'File Format',
      field: 'fileFormat',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.format}
          </div>
        </>
      ),
    },
    {
      title: 'Description',
      field: 'description',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          {/* <MouseOverPopover ***Code may require***
            data={rowData.description}
            popOverData={rowData.description}
          /> */}
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.description}
          </div>
        </>
      ),
    },
  ];

  const tableRef = createRef();
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [status, setStatus] = useState(false);
  useEffect(() => {
    if ((tableRef?.current && submit) || status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [submit, status]);
  useEffect(() => {
    setResetData(null);
  }, []);
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    httpPaginationDelete(`enableintegration/delete/enablefileformat/${deleteData?.id}`)
      .then((response) => {
        if (response?.status === 200) {
          setMessage(response?.response);
          setTimeout(() => {
            setMessage('');
          }, 3000);
          setIsDelete(false);
          setStatus(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete File Format"
        value={`Are you sure you want to delete this File Format?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `enableintegration/search/enablefileformats`;
                const bodyObj = {
                  format: searchData?.fileFormat ? searchData?.fileFormat : '',
                  description: searchData?.description ? searchData?.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: '',
                  orderDirection: '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  search: '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setEnableCode('');
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              toolbarButtonAlignment: 'left',
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              (rowData) => ({
                icon: () => <PlayCircleFilledWhiteOutlinedIcon />,
                tooltip: 'Run Enable',
                onClick: (event, rowData) => {
                  setOpen(true);
                  setJobCode(rowData?.format);
                },
              }),
              {
                icon: () => (
                  <>
                    <FileCopyOutlinedIcon className={classes.copyButtonroot} />
                  </>
                ),
                tooltip: 'Copy',
                onClick: (event, rowData) => {
                  setTabValue(1);
                  setResetData(rowData?.id);
                  dispatch(fetchEnableFileFormatData(rowData?.id));
                },
              },
              (rowData) => {
                return {
                  icon: () => (
                    <>
                      <DeleteOutlineOutlinedIcon />
                    </>
                  ),
                  tooltip: 'Delete',
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                };
              },
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn`}
                    >
                      Add Enable File Format
                    </Button>
                  </>
                ),
                isFreeAction: true,
                onClick: (event) => {
                  setTabValue(1);
                },
              },
            ]}
            onRowClick={(event, rowData) => {
              setTabValue(1);
              dispatch(fetchEnableFileFormatData(rowData?.id));
              setEnableCode(rowData.format);
            }}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
          />
          {message && <SuccessSnackbar successMsg={message} />}
        </div>
      </Grid>
    </>
  );
}
